import React, { Component } from "react";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Card, Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";
import Subscription from "~/models/Subscription/Subscription";
import SubscriptionStatus from "~/constants/Subscription/SubscriptionStatus";

@observer
class SubscriptionStatusInactiveCardContext extends Component {
  render() {
    const { t, subscription } = this.props;

    if (subscription.status !== SubscriptionStatus.INACTIVE) {
      return null;
    }

    return (
      <Card.Content extra>
        <Message warning>{t("billingCentral:subscriptionInactiveMessage")}</Message>
      </Card.Content>
    );
  }
}

SubscriptionStatusInactiveCardContext.propTypes = {
  t: PropTypes.func.isRequired,
  subscription: PropTypes.instanceOf(Subscription),
};

export default withTranslation()(SubscriptionStatusInactiveCardContext);
